import { BreakpointTrackerContext } from '@jutro/layout';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, { useCallback, useContext, useState, useEffect } from 'react';
import { Loader } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import metadata from './DiscountsPage.metadata.json5';
import messages from './DiscountsPage.messages.js';
import styles from './DiscountsPage.module.scss';


function TFPADiscountsPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { wizardData: submissionVM } = props;
    const [homeSecurityDeviceValue, setHomeSecurityDeviceValue] = useState();
    const translator = useTranslator();
    const [isLoading, setIsLoading] = useState(false);

    const policyTypeCode = submissionVM?.value.lobData?.homeowners_tfpa?.coverables_Ext?.yourHome?.policyType_Ext;


    useEffect(() => {
        const homeSecurityDeviceVal = _.get(submissionVM.value, 'lobData.homeowners_tfpa.coverables_Ext.rating.homeSecurityDeviceCredit_Ext');

        setHomeSecurityDeviceValue(homeSecurityDeviceVal);
    }, [submissionVM.value]);

    const onNext = useCallback(async () => {
        // All fields were read-only, so didn't added any call
    }, []);


    const overrideProps = {
        '@field': {
            // apply to all fields
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        homeSecurityDevice: {
            visible: policyTypeCode !== 'DP2',
            value: homeSecurityDeviceValue,
            showRequired: true,
            readOnly: true
        },
        explanationSection: {
            visible: policyTypeCode !== 'DP2',
        },
        homeSecurityContent: {
            content: translator(messages.homeSecurityExplanation)
        },
        automaticSprinklerContent: {
            content: translator(messages.automaticSprinklerExplanation)
        },
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    const skip = useCallback(async vm => {
        const ppStatus = _.get(submissionVM.value, 'baseData.periodStatus') 
        || _.get(submissionVM.value, 'status');
    
        return ppStatus === 'Quoted';
    }, [submissionVM]);

    return (

        <WizardPage
            onNext={onNext}
            skipWhen={skip}
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    overrideProps={overrideProps}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </Loader>
        </WizardPage>
    );
}

TFPADiscountsPage.propTypes = wizardProps;
export default TFPADiscountsPage;
